<template>
  <div>
    <div class="container" v-if="isShow">
      <div class="card" style="padding: 5px">
        <van-tabs v-model="active">
          <van-tab :title="type == 'needId'?'需求发送':'收款认领'">
            <div class="tagTitle">
              <van-tag type="success">{{ type == 'needId'?'需求信息':'收款信息' }}</van-tag>
              <van-tag :type="typeArr[payInfo.checkStatus]" plain style="margin-right: 15px">{{type == 'needId'?statusArr[payInfo.checkStatus].replace('认领','发送'):statusArr[payInfo.checkStatus]}}</van-tag>
            </div>
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">付款单位：</span>
                <span class="value">{{ payInfo.custName }}</span>
              </div>
              <div class="item" >
                <span class="key">{{type == 'needId'?'付款':'收款'}}金额：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{payInfo.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(payInfo.payMoney)}}</span>
                </span>
              </div>
              <div class="item" >
                <span class="key">{{type == 'needId'?'可发送':'可认领'}}：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{payInfo.noConfirmMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(payInfo.noConfirmMoney)}}</span>
                </span>
              </div>
              <div class="item" >
                <span class="key">{{type == 'needId'?'已发送':'已认领'}}：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{payInfo.confirmMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(payInfo.confirmMoney)}}</span>
                </span>
              </div>
              <div class="item" v-if="type !== 'needId'">
                <span class="key">待确认：</span>
                <span class="value" style="color: #F56C6C">
                  ￥{{payInfo.totalMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(payInfo.totalMoney)}}</span>
                </span>
              </div>
              <div class="item" >
                <span class="key">对应业务员：</span>
                <span class="value">{{ payInfo.userName }}</span>
              </div>
              <div class="item" >
                <span class="key">对应业务员数量：</span>
                <span class="value">{{ payInfo.userCount }}</span>
              </div>
              <div class="item" >
                <span class="key">对应合同数量：</span>
                <span class="value">{{ payInfo.contractCount }}</span>
              </div>
              <!-- <template v-if="payInfo.checkStatus == 4 || payInfo.checkStatus == 3">
                <div class="item">
                  <span class="key">异常合同信息：</span>
                  <span class="value">{{ payInfo.contractItem }}</span>
                </div>
                <div class="item" style="padding-left:70px;text-indent:-70px;">
                  <span class="key">异常类型：</span>
                  <span class="value" style="color: #ee0a24;">{{ payInfo.abnormalContractStatus }}</span>
                </div>
              </template> -->
              <div class="item" >
                <span class="key">{{ type === 'contNewIncomeId'?'收款主体':'付款主体' }}：</span>
                <span class="value">{{ payInfo.companyName }}</span>
              </div>
              <div class="item" >
                <span class="key">{{type == 'needId'?'需求账号':'收款账号'}}：</span>
                <span class="value">{{ payInfo.payBank + '  ' + payInfo.payBankAccountNo}}</span>
              </div>
              <div class="item">
                <span class="key">{{type == 'needId'?'需求时间':'收款时间'}}：</span>
                <span class="value">{{payInfo.payDate}}</span>
              </div>
              <div class="item" v-if="type !== 'needId'">
                <span class="key">添加信息：</span>
                <span class="value">{{payInfo.createBy + '  ' + payInfo.createTime}}</span>
              </div>
              <div class="item" v-if="payInfo.userName">
                <span class="key">对应部门/人：</span>
                <span class="value" v-for="(item,index) in payInfo.userName.split(',')" :key="index">
                  <span v-if="payInfo.deptName">{{payInfo.deptName.split(',')[index]}}</span>/
                  <span style="color: #409EFF">{{item}}</span>
                  <span v-if="index != payInfo.userName.split(',').length - 1">,</span>
                </span>
              </div>
              <div class="item">
                <span class="key">{{type == 'needId'?'需求短信':'收款短信'}}：</span>
                <span class="value">{{payInfo.msgContent}}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="操作日志">
            <div class="item">
              <van-steps direction="vertical" :active="100">
                <van-step v-for="(item,index) in operationLogList" :key="index">
                  <span style="font-weight: bold">{{item.remark}}</span>
                  <span style="margin-left: 8px">{{item.createTime}}</span>
                  <div v-for="(val,label) in item.listData" :key="label">
                    <div class="contLogSp">
                      <div>
                        <van-image style="width: 0.6rem; height: 0.6rem" :src="val.avatar" ></van-image>
                        <span style="margin-left: 10px;">{{val.userName}}</span>
                      </div>
                      <div>
                        <van-tag size="mini" :type="val.spStatus == 2?'success':val.spStatus == 3?'danger':'warning'">{{val.spStatus == 2?'已通过':val.spStatus == 3?'驳回':'审批中'}}</van-tag>
                        <span></span>
                        <span v-if="val.spTime" style="margin-left: 10px;">{{val.spTime}}</span>
                      </div>
                    </div>
                    <div v-if="val.spComment">{{val.spComment}}</div>
                  </div>
                </van-step>
              </van-steps>
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" :column-num="2" v-if="payInfo.checkStatus==2 || payInfo.checkStatus == 3">
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:newIncomeDetail:add']" v-if="payInfo.noConfirmMoney > 0" @click="handleClaim(payInfo,'add')">
            <van-icon name="certificate" size="22" color="#07c160" />
            <span>{{type == 'needId'?'发送':'认领'}}</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-if="(payInfo.checkStatus==2 || payInfo.checkStatus == 3) && isNotMine" @click="notMine(payInfo[type])">
            <van-icon name="warning-o" size="22" color="#ff976a" />
            <span>不是我的</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-grid class="grid-wrap" :column-num="1" v-if="payInfo.userCount > 1 && payInfo.checkStatus == 3" v-hasPermi="['cont:newIncomeDetail:noAgreeMatch']">
        <van-grid-item>
          <div class="flex-center" @click="handleClaim(payInfo,'noAgreeMatch')">
            <van-icon name="failure" size="22" color="#ee0a24" />
            <span>异议</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-grid class="grid-wrap" :column-num="2" v-if="payInfo.checkStatus == 1 || payInfo.checkStatus == 2" >
        <van-grid-item >
          <div class="flex-center" v-hasPermi="['cont:newIncome:makeIdentification']" @click="handleAgain(payInfo)">
            <van-icon name="revoke" size="22" color="#ff976a" />
            <span>{{type == 'needId'?'需求识别':'收款识别'}}</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:newIncome:del']" @click="remove(payInfo[type])">
            <van-icon name="delete" size="22" color="#ee0a24" />
            <span>删除</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-tabs v-model="listActive" color="#1989fa" title-active-color="#1989fa" v-if="historicalClaimList.length > 0 || toBeConfirmedList.length > 0">
        <van-tab title="待确认信息" v-if="toBeConfirmedList.length > 0">
          <div class="card" style="padding: 5px" >
            <van-list>
              <van-cell v-for="(item,index) in toBeConfirmedList" :key="index">
                <div class="flex-between" v-if="item" style="align-items: flex-start">
                  <div class="contract_detail">
                    <div style="display: flex; justify-content: flex-end;">
                      <van-tag :type="item.getStatus == 1?'warning':'primary'" plain >{{item.getStatus == 1 ? '待确认':'已确认'}}</van-tag>
                    </div>
                    <div class="item">
                      <span class="key">合同编号：</span>
                      <span class="value">{{ item.contractNum }}</span>
                    </div>
                    <div class="item">
                      <span class="key">合同名称：</span>
                      <span class="value">{{ item.contractName }}</span>
                    </div>
                    <div class="item">
                      <span class="key">{{type == 'needId'?'发送金额':'认领金额'}}：</span>
                      <span class="value" style="color: #F56C6C">
                        ￥{{item.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(item.payMoney)}}</span>
                      </span>
                    </div>
                    <div class="item">
                      <span class="key">发起方信息：</span>
                      <span class="value">{{ item.deptName }} {{ item.userName }}</span>
                    </div>
                    <!-- <div class="item">
                      <span class="key">接收方信息：</span>
                      <span class="value">{{ item.receiveDeptName }} {{ item.receiveUserName }}</span>
                    </div> -->
                    <!-- <div class="item">
                      <span class="key">确认状态：</span>
                      <span class="value">{{ item.getStatus == 1 ? '未确认':'已确认' }}</span>
                    </div> -->
                  </div>
                </div>
                <div style="text-align: center; margin-top: 10px">
                  <van-button size="small" type="info" v-if="item.getStatus == 1"
                    @click="handleConfirm(item[typeMsg])" style="padding: 0 20px; border-radius: 5px;" v-hasPermi="['cont:newIncomeDetail:finaConfirm']">确认</van-button>
                  <!-- <van-button size="small" type="primary"
                    @click="handleExecutiveDetail(item[typeDetail], item.channelType)" style="margin-left: 10px;padding: 0 20px; border-radius: 5px;">分账明细</van-button> -->
                </div>
              </van-cell>
            </van-list>
          </div>
        </van-tab>
        <van-tab :title="type == 'needId'?'发送信息':'认领信息'" v-if="historicalClaimList.length > 0">
          <div class="card" style="padding: 5px" >
            <van-list>
              <van-cell v-for="(item,index) in historicalClaimList" :key="index">
                <div class="flex-between" v-if="item" style="align-items: flex-start">
                  <div class="contract_detail">
                    <div style="display: flex; justify-content: flex-end;">
                      <van-tag :type="typeArr2[item.getStatus]" plain style="margin-right: 15px">{{statusArr2[item.getStatus]}}</van-tag>
                    </div>
                    <div class="item">
                      <span class="key">合同编号：</span>
                      <span class="value">{{ item.contractNum }}</span>
                    </div>
                    <div class="item">
                      <span class="key">合同名称：</span>
                      <span class="value">{{ item.contractName }}</span>
                    </div>
                    <div class="item" v-if="type == 'needId' && item.execCustName">
                      <span class="key">执行客户名称：</span>
                      <span class="value">{{ item.execCustName }}</span>
                    </div>
                    <div class="item">
                      <span class="key">{{type == 'needId'?'发送':'认领'}}信息：</span>
                      <span class="value">{{ item.deptName }} {{ item.userName }}</span>
                    </div>
                    <div class="item">
                      <span class="key">{{type == 'needId'?'发送':'认领'}}金额：</span>
                      <span class="value" style="color: #F56C6C">
                        ￥{{item.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(item.payMoney)}}</span>
                      </span>
                    </div>
                    <div class="item">
                      <span class="key">预充值金额：</span>
                      <span class="value" style="color: #F56C6C">
                        ￥{{item.preRechargeMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(item.preRechargeMoney)}}</span>
                      </span>
                    </div>
                    <div class="item">
                      <span class="key">垫款回款金额：</span>
                      <span class="value" style="color: #F56C6C">
                        ￥{{item.advancesInMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(item.advancesInMoney)}}</span>
                      </span>
                    </div>
                    <div class="item">
                      <span class="key">充值剩余金额：</span>
                      <span class="value" style="color: #F56C6C">
                        ￥{{item.rechargeRemainMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(item.rechargeRemainMoney)}}</span>
                      </span>
                    </div>
                    <div class="item">
                      <span class="key">服务费：</span>
                      <span class="value" style="color: #F56C6C">
                        ￥{{item.exposureMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(item.exposureMoney)}}</span>
                      </span>
                    </div>
                    <div class="item" v-if="item.getStatus == 5">
                      <span class="key">付款截图：</span>
                      <van-button type="info" size="mini" plain @click="showImg(item.payImg)" v-if="item.payImg">点击查看</van-button>
                      <span class="value" v-else>无</span>
                    </div>
                    <div class="item" v-if="item.getStatus == 5">
                      <span class="key">异议原因：</span>
                      <span class="value">{{ item.reason }}</span>
                    </div>
                  </div>
                </div>
                <div style="text-align: center; margin-top: 10px" v-if="isChannel">
                  <van-button size="small" color="#ee0a24" v-if="item.getStatus !== 2" @click="handleUnbind(item[typeDetail])"
                    v-hasPermi="['cont:newContract:editAdmin']" style="padding: 0 20px; border-radius: 5px;">管理员解除绑定</van-button>
                  <van-button size="small" color="#ee0a24" v-if="item.userId == $store.state.user.user.userId && (item.getStatus == 3 || item.getStatus == 4)" @click="handleUnbind(item[typeDetail])"
                    v-hasPermi="['cont:newIncomeDetail:relieve']" style="padding: 0 20px; border-radius: 5px;">解除绑定</van-button>
                  <van-button size="small" color="#ee0a24" v-if="item.userId == $store.state.user.user.userId && item.getStatus == 4 && payInfo.userCount > 1"
                    @click="handleReissue(item[typeDetail])" v-hasPermi="['cont:newIncomeDetail:relieve']" style="padding: 0 20px; border-radius: 5px;margin-left: 10px;">{{type == 'needId'?'重新发送':'重新认领'}}</van-button>
                  <!-- <van-button size="small" type="primary"
                    @click="handleExecutiveDetail(item[typeDetail], item.channelType)" style="margin-left: 10px;padding: 0 20px; border-radius: 5px;">分账明细</van-button> -->
                </div>
              </van-cell>
            </van-list>
          </div>
        </van-tab>
      </van-tabs>
      <van-dialog v-model="claimVisible" :title="isObjection?'提交异议':type == 'needId'?'需求发送':'收款认领'" width="95%" style="height:80%" class="verifyClue" :beforeClose="claimBeforeClose" show-cancel-button>
        <van-form ref="claimForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">

          <van-field readonly clickable v-model="claimForm.contractName" @click="openSelect" label="合同信息" placeholder="请选择合同信息" :rules="[{ required: true }]" required />
          <van-cell title="提示信息：请选择相对应的合同信息" style="color: #ff976a;"></van-cell>
          <van-collapse v-model="activeDetail" v-if="claimForm.contractId">
            <van-collapse-item title="查看合同详情" name="1">
              <div class="contract_detail">
                <div class="item">
                  <span class="key">我方签约主体机构：</span>
                  <span class="value">{{ contInfo.companyName }}</span>
                </div>
                <div class="item">
                  <span class="key">合同执行时间：</span>
                  <span class="value">{{ contInfo.startTime }}至{{ contInfo.endTime }}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">垫款方式：</span>
                  <span class="value">{{formatHandel('payType',contInfo.payType)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">框架类型：</span>
                  <span class="value">{{formatHandel('frameType',contInfo.frameType)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">客户来源：</span>
                  <span class="value">{{formatHandel('custSource',contInfo.custSource)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">授信账期：</span>
                  <span class="value">{{contInfo.creditCycleType?`${contInfo.creditCycleValue}个${formatHandel('creditCycleType',contInfo.creditCycleType)}`:'--'}}</span>
                </div>
                <div class="item">
                  <span class="key">合同金额(元)：</span>
                  <span class="value" style="color: #F56C6C">
                    ￥{{contInfo.contractMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.contractMoney)}}</span>
                  </span>
                </div>
                <div class="item">
                  <span class="key">合同累计回款(元)：</span>
                  <span class="value" style="color: #F56C6C">
                    ￥{{contInfo.allReturnedMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.allReturnedMoney)}}</span>
                  </span>
                </div>
                <div class="item">
                  <span class="key">合同授信额度(元)：</span>
                  <span class="value" style="color: #F56C6C">
                    ￥{{contInfo.advancesMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.advancesMoney)}}</span>
                  </span>
                </div>
                <div class="item" v-if="contInfo.creditTotalMoney || contInfo.creditTotalMoney == 0">
                  <span class="key">累计垫款总额(元)：</span>
                  <span class="value" style="color: #F56C6C">
                    ￥{{contInfo.creditTotalMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.creditTotalMoney)}}</span>
                  </span>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
          <van-field v-if="contInfo.custSource == 2" readonly clickable v-model="claimForm.execCustName" @click="showPicker('execCustomer')" label="执行客户" placeholder="请选择执行客户" :rules="[{ required: true }]" required />
          <van-field v-model="claimForm.payMoney" label="确认金额(元)" placeholder="请输入确认金额" @blur="getSum('payMoney')" :rules="[{ required: true }]" type="number" maxlength="11" required />
          <van-cell title="提示信息：确认金额为当前合同本次收款的金额" style="color: #ff976a;"></van-cell>
          <van-cell title="回款状态：" required>
            <template>
              <!-- :disabled="contInfo.creditTotalMoney<=0 || !contInfo.creditTotalMoney" -->
              <van-radio-group v-model="claimForm.incomeType" direction="horizontal" @change="incomeTypeChange" :disabled="incomeTypeDisabled">
                <van-radio :name="0" clickable>正常回款</van-radio>
                <van-radio :name="1" clickable>垫款回款</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <template v-if="claimForm.incomeType || claimForm.incomeType === 0">
            <van-field v-if="claimForm.incomeType == 1" v-model="claimForm.advancesInMoney" label="垫款回款金额" placeholder="请输入垫款回款金额(元)" @blur="verifiMoney('advancesInMoney')" :rules="[{ required: true }]" type="number" maxlength="11" required />
            <van-cell style="color: #1989fa;" :title="'预充值金额:￥' + claimForm.preRechargeMoney"></van-cell>
            <!-- <van-cell v-if="claimForm.incomeType == 1" style="color: #1989fa;" :title="'垫款回款金额: ￥' + claimForm.advancesInMoney"></van-cell> -->
            <van-cell v-if="advancesPayMoney" style="color: #1989fa;" :title="'累计垫款未回款: ￥' + advancesPayMoney"></van-cell>
          </template>
          <!-- :disabled="payMoneyDisabled"  -->
          <van-cell title="是否有服务费：" required>
            <template>
              <van-radio-group v-model="claimForm.isExposure" direction="horizontal" @change="exposureChange" :disabled="claimForm.preRechargeMoney === 0 && !claimForm.exposureMoney">
                <van-radio :name="0" clickable>否</van-radio>
                <van-radio :name="1" clickable>是</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field v-if="claimForm.isExposure == 1" v-model="claimForm.exposureMoney" label="服务费" placeholder="请输入服务费(元)" @blur="verifiMoney('exposureMoney')" :rules="[{ required: true }]" type="number" maxlength="11" required />
          <template v-if="isObjection">
            <van-field v-model="claimForm.payImg" label="付款截图" placeholder="请点击下方上传付款截图" :rules="[{ required: true }]" required readonly />
            <van-uploader class="pictureList" v-model="pictureList" :max-count="1" :after-read="uploadPictureFiles" :before-read="beforeRead" :before-delete="handleRemove" @oversize="onOversize" :max-size="10000 * 1024" />
            <van-field v-model="claimForm.reason" label="异议原因" placeholder="请输入异议原因" type="text" :rules="[{ required: true }]" required />
          </template>
          <van-field v-model="claimForm.remark" rows="2" autosize label="备注" placeholder="备注信息" type="textarea" show-word-limit />
          <template v-if="type === 'needId' && claimForm.contractId">
            <van-button v-if="claimForm.divideAccountList.length == 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addExecutive">+增加分账明细</van-button>
            <van-collapse v-model="activeNames" v-if="claimForm.preRechargeMoney !== 0">
              <van-collapse-item :title="'分账明细'+(index+1)" :name="index" v-for="(item,index) in claimForm.divideAccountList" :key="index+'01'">
                <!-- <van-field v-model="item.fundTypeName" label="资金类型" placeholder="请选择资金类型" readonly clickable  @click="showPicker('fundType',index)" :rules="[{ required: true }]" required />
                <van-field v-if="(item.fundType == '1' || item.fundType == '2') && contInfo.channelType == 2" v-model="item.execCustomerName" label="执行客户"
                  placeholder="请选择执行客户" readonly clickable  @click="showPicker('execCustomer',index)" :rules="[{ required: true }]" required /> -->
                <van-field v-model="item.projectName" label="项目名称"
                  placeholder="请选择项目名称" readonly clickable  @click="showPicker('project',index)" :rules="[{ required: true }]" required />
                <van-field v-if="item.projectId" v-model="item.accountId" label="账户ID"
                  placeholder="请选择账户ID" readonly clickable  @click="showPicker('accountId',index)" />
                <van-field v-model="item.payMoney" label="客户现金金额" placeholder="请输入客户现金金额(元)"
                  @blur="getPayMoney('payMoney',item.payMoney,index)" type="number" maxlength="11" :rules="[{ required: true }]" required />
                <van-field v-if="item.projectId" v-model="item.percentage" label="客户返点(%)" readonly required />
                <van-field v-if="item.projectId && item.payMoney" v-model="item.rechargeMoney" label="账户币" readonly required />
                <van-field v-if="item.projectId" v-model="item.channelPercentage" label="渠道返点(%)" readonly required />
                <van-field v-if="item.projectId && item.payMoney" v-model="item.channelPayMoney" label="渠道现金" readonly required />

                <div class="link">
                  <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addExecutive">+分账明细</van-button>
                  <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deleteExecutive(index)">删除</van-button>
                </div>
              </van-collapse-item>
            </van-collapse>
          </template>
          <!-- <van-button v-if="claimForm.flowList.length == 0 && this.contInfo.contractId && claimForm.preRechargeMoney !== 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addExecutive">+增加分账明细</van-button>
          <van-collapse v-model="activeNames" v-if="claimForm.preRechargeMoney !== 0">
            <van-collapse-item :title="'分账明细'+(index+1)" :name="index" v-for="(item,index) in claimForm.flowList" :key="index+'01'">
              <van-field v-model="item.fundTypeName" label="资金类型" placeholder="请选择资金类型" readonly clickable  @click="showPicker('fundType',index)" :rules="[{ required: true }]" required />
              <van-field v-if="(item.fundType == '1' || item.fundType == '2') && contInfo.channelType == 2" v-model="item.execCustomerName" label="执行客户"
                placeholder="请选择执行客户" readonly clickable  @click="showPicker('execCustomer',index)" :rules="[{ required: true }]" required />
              <van-field v-if="item.fundType == 1 || item.fundType == 2" v-model="item.projectName" label="项目名称"
                placeholder="请选择项目名称" readonly clickable  @click="showPicker('project',index)" :rules="[{ required: true }]" required />
              <van-field v-if="(item.fundType == 1 || item.fundType == 2) && item.projectId" v-model="item.rechargeMoney" label="账户币"
                placeholder="请输入账户币" @blur="getPayMoney('rechargeMoney',item.rechargeMoney,index)" type="number" maxlength="11" :rules="[{ required: true }]" required />
              <van-field v-model="item.payMoney" label="现金金额(元)" placeholder="请输入现金金额"
                @blur="getPayMoney('payMoney',item.payMoney,index)" type="number" maxlength="11" :rules="[{ required: true }]" required />
              <div class="link">
                <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addExecutive">+分账明细</van-button>
                <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deleteExecutive(index)">删除</van-button>
              </div>
            </van-collapse-item>
          </van-collapse> -->
        </van-form>
      </van-dialog>

      <!-- 合同列表弹窗 -->
      <van-dialog v-model="selectVisible" class="contract" width="97%" style="height: 80%;overflow: scroll;" title="选择合同" :showConfirmButton = 'false' :close-on-click-overlay="true">
        <van-search v-model="contractName" placeholder="请输入合同名称或合同编号搜索" @search="onSearch"/>
        <van-list class="van-list" v-model="contractLoading" style="height: 80%;" :finished="true" v-if="newIncomeContList.length > 0">
          <van-cell-group v-for="(item,index) in newIncomeContList" :key="index" style="padding-bottom: 10px;">
            <div class="flex-c-center" v-if="item">
              <div style="flex: 1">
                <div style="color: #666;font-size: 14px;padding: 10px 20px;line-height: 22px">
                  <div>合同编号：<span style="color: #333;">{{item.contractNum}}</span></div>
                  <div style="padding-left:70px;text-indent:-70px;">合同标题：<span style="color: #333;">{{item.contractName}}</span></div>
                  <div v-if="$route.query.type == 'payment'">主体机构：<span style="color: #333;">{{item.companyName}}</span></div>
                  <div v-if="$route.query.type == 'channel'">客户名称：<span style="color: #333;">{{item.custName}}</span></div>
                  <div>客户来源：<span style="color: #333;">{{formatHandel("custSource",item.custSource)}}</span></div>
                  <div>执行时间：<span style="color: #333;">{{item.startTime}}至{{item.endTime}}</span></div>
                  <div v-if="item.errorMsg" style="padding-left:70px;text-indent:-70px;">合同状态：<span style="color: #ee0a24;">{{item.errorMsg}}</span></div>
                  <div>用户名称：<span style="color: #333;">{{item.userName}}</span></div>
                  <!-- <div v-if="item.errorMsg">申请审核状态：
                    <van-tag color="#f7f8fa;" v-if="item.incomeVerify == 1">未申请</van-tag>
                    <van-tag type="warning" v-if="item.incomeVerify == 2">处理中</van-tag>
                    <van-tag type="success" v-if="item.incomeVerify == 3">审核通过</van-tag>
                    <van-tag type="danger" v-if="item.incomeVerify == 4">审核驳回</van-tag>
                  </div> -->
                </div>
              </div>
            </div>
            <!-- <van-button v-if="item.errorMsg && (item.incomeVerify == 1 || item.incomeVerify == 4)" style="width: 30%;margin: 0 auto" size="mini" type="warning" block @click="handleApply(item)">申请</van-button> -->
            <van-button style="width: 30%;margin: 0 auto" size="mini" type="info" block @click="selectContract(item)">选择</van-button>
            <!-- <van-cell  style="padding-top: 20px;padding-bottom: 20px">
              <template #right-icon>
                <van-button type="warning" size="mini" plain @click="selectContract(item)">选择</van-button>
              </template>
            </van-cell> -->
          </van-cell-group>
        </van-list>
        <empty v-if="newIncomeContList.length == 0" />
      </van-dialog>

      <!-- 分账明细 -->
      <van-dialog v-model="showExecutive" class="contract" width="97%" style="height: 80%;overflow: scroll;" title="分账明细" :showConfirmButton = 'false' :close-on-click-overlay="true">
        <van-list class="van-list" v-model="loading" style="height: 80%" :finished="true" v-if="executiveList.length > 0">
          <van-cell v-for="(item,index) in executiveList" :key="index">
            <div class="flex-between">
              <div>
                <!-- <div class="contractName-wrap"> <div class="contractName"> {{ item.contractName }} </div> </div> -->
                <!-- <div style="color: #333; font-size: 12px" v-if="channelType != 1">执行客户：{{item.execCustomerName}}</div> -->
                <div v-if="item.fundType == 2 || item.fundType == 1" style="color: #333; font-size: 12px; padding-left:60px;text-indent:-60px;">项目名称：{{`【${item.projectId}】：${getValue(item.projectName)} | ${item.industryName?item.industryName : '-'}`}}</div>
                <div style="color: #333; font-size: 12px">资金类型：{{ formatHandel('fundType',item.fundType) }}</div>
                <div v-if="item.fundType == 2 || item.fundType == 1" style="color: #1989fa; font-size: 12px">账户币：{{item.rechargeMoney}}</div>
                <div style="color: #07c160; font-size: 12px">充值金额(元)：{{item.payMoney}}</div>
              </div>
            </div>
          </van-cell>
        </van-list>
        <empty v-if="executiveList.length == 0" />
      </van-dialog>
      <van-image-preview v-model="imageShow" :images="imageArr">
        <!-- <template v-slot:index>第{{ index }}页</template> -->
      </van-image-preview>
      <van-popup v-model="picker.visible" position="bottom">
        <van-search v-model="authIdQuery.accountId" placeholder="请输入账户ID查询" @search="onSearchAccount" @input="onSearchAccount" v-if="picker.formKey == 'accountId'" />
        <van-search v-model="searchValue" placeholder="请输入合同名称搜索" @search="onSearch" v-if="picker.formKey == 'contract'" />
        <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import channel from '@/api/channel/channel'
import { getValue } from '@/utils/util'
// import { getDicts } from '@/api/system/dict/data'
import newContract from '@/api/cont/newContract'
import { Toast, Dialog, ImagePreview } from 'vant'
import Empty from '@/components/common/Empty'
let api = null
export default {
  components: {
    Empty,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {
      mainId: null,
      type: null,
      typeDetail: null,
      typeMsg: null,

      isShow: false,
      active: 0,
      listActive: 0,
      activeName: '',
      contNewIncomeId: '',
      paymentFormShow: false,
      contForm: {},
      pointList: [],
      payInfo: {},
      operationLogList: [], // 操作日志
      contractFileList: [], // 合同附件
      fileFinished: true,
      verifyFormShow: false,
      verifyForm: {
        checkStatus: '2',
        checkReason: '',
        contIncomeId: ''
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      styleArr: ['success', 'warning', 'primary', 'danger'],
      statusArr: ['', '未认领公海', '未认领', '部分认领', '已认领', '异常'],
      typeArr: ['', 'danger', 'danger', 'warning', 'success', 'default'],
      statusArr2: ['', '已认领', '已解绑', '待确认', '异常', '提交异常'],
      typeArr2: ['', 'success', 'default', 'warning', 'danger', 'danger'],
      options: {
        checkStatusOptions: [],
        frameTypeOptions: [],
        fundTypeOptions: [],
        checkReasonTypeOptions: [],
        fileTypeOptions: [],
        creditCycleTypeOptions: [],
        channelCompanyOptions: [] // 渠道公司
      },
      imageShow: false,
      imageArr: [],
      toBeConfirmedList: [],
      historicalClaimList: [],
      getStatus: [],
      claimVisible: false,
      claimForm: {
        incomeType: null,
        payMoney: null,
        preRechargeMoney: null,
        advancesInMoney: null,
        isExposure: 0,
        exposureMoney: null,
        contractId: null,
        contactName: null,
        divideAccountList: [], // 渠道分账明细
        contractStatus: null
      },
      advancesInMoney: null, // 接口拿垫款回款金额
      preRechargeMoney: null, // 接口拿预充值金额
      pictureList: [],
      contInfo: {}, // 合同信息
      isObjection: false, // 是否异议
      payMoneyDisabled: false, // 金额是否可输入
      activeDetail: [],
      contractId: null,
      newIncomeContList: [],
      claimedMoney: 0,
      isNotMine: false,

      // 搜索关键字
      searchValue: null,

      // 分账
      index: null,
      activeNames: [0],

      // 分账明细
      showExecutive: false,
      executiveList: [],
      loading: false,
      channelType: null,

      authIdQuery: {
        pageNum: 1,
        pageSize: 100,
        projectId: null,
        accountId: null
      },
      accountNoList: [],

      // 判断是否渠道三公司
      isChannel: true,

      // 选择合同
      selectVisible: false,
      contractName: null,
      contractLoading: false,

      // 选择项目名称
      projectList: [],

      execCustomerId: null,
      execCustomerList: [],

      applyForm: {
        contractId: null,
        bussId: null,
        bussType: null,
        errorMsg: null
      },

      // 垫款累计未回款
      advancesPayMoney: null,
      incomeTypeDisabled: true
    }
  },
  async created() {
    if (this.$route.query) {
      this.mainId = this.$route.query.id
      if (this.$route.query.type == 'payment') {
        api = payment
        this.type = 'contNewIncomeId'
        this.typeDetail = 'contNewIncomeDetailId'
        this.typeMsg = 'contNewIncomeMsgId'
      } else if (this.$route.query.type == 'channel') {
        api = channel
        this.type = 'needId'
        this.typeDetail = 'needDetailId'
        this.typeMsg = 'needMsgId'
      }
    }
  },
  async mounted() {
    sessionStorage.setItem('paymentSearch', true)
    await this.getDicts('sys_money_type').then(res => {
      this.options.fundTypeOptions = this.setDictToInt(res)
    })
    await this.getOptions()
    await this.getPayInfo()
    // this.getDicts('check_reason_type').then(res => {
    //   this.options.checkReasonTypeOptions = this.setDictToInt(res)
    // })
    api.notMine({ [this.type]: this.mainId }).then(res => {
      if (res.code == 200) {
        this.isNotMine = res.data != 1
      }
    })
    this.init()
  },
  methods: {
    async init() {
      if (this.type === 'needId') {
        document.title = '发送详情'
      } else {
        document.title = '收款详情'
      }
    },
    async getPayInfo(id) {
      const res = await api.getNewIncome(id || this.mainId)
      if (res.code === 200) {
        this.payInfo = res.data
        this.isChannel = !this.options.channelCompanyOptions.some(res => { return res.dictLabel === this.payInfo.custName })
        this.isShow = true
      }
      api.noConfirmedList({ [this.type]: res.data[this.type] }).then(res => {
        if (res.code == 200) {
          this.toBeConfirmedList = res.data
        }
      })
      api.listNewIncomeDetail({ [this.type]: res.data[this.type] }).then(response => {
        if (response.code == 200) {
          this.historicalClaimList = response.rows
        }
      })
      // }
      this.getLogList()
    },
    // 获取操作记录
    async getLogList() {
      const params = {
        contractId: this.mainId,
        bigType: this.type == 'contNewIncomeId' ? 4 : 6
      }
      newContract.listContractLog(params).then(response => {
        this.operationLogList = response.rows
      })
    },
    // 弹出选择合同列表
    openSelect() {
      this.getContractList()
      this.selectVisible = true
    },
    async getContractList() {
      await api.newIncomeCont({ [this.type]: this.payInfo[this.type], custName: this.payInfo.custName }).then(res => {
        if (res.code == 200) {
          // if (res.data.length == 0) {
          //   Toast.fail('该收款信息暂无签约合同记录，请先完善客户合同信息再确认认领。')
          //   return
          // }
          this.contractLoading = true
          this.newIncomeContList = res.data
        }
      })
    },
    async onSearch() {
      await this.getContractList()
      this.newIncomeContList = this.newIncomeContList.filter(item => {
        return item.contractName.indexOf(this.contractName) > -1 || item.contractNum.indexOf(this.contractName) > -1
      })
      // this.picker.columns = this.newIncomeContList.map((ele) => ele.contractNum + '  ' + ele.contractName)
    },
    handleApply(row) {
      const that = this
      this.applyVisible = true
      this.applyForm.contractId = row.contractId
      this.applyForm.errorMsg = row.errorMsg
      if (this.type == 'contNewIncomeId') {
        this.applyForm.bussId = this.payInfo.contNewIncomeId
        this.applyForm.bussType = 1
      } else if (this.type == 'needId') {
        this.applyForm.bussId = this.payInfo.needId
        this.applyForm.bussType = 2
      }
      Dialog.confirm({
        title: '提示',
        message: '1、如未续签新合同，请重新走合同流程后，再收款识别后认领；\n 2、如老合同回款，提交申请，由财务审批后可认领；',
        messageAlign: 'left',
        confirmButtonText: '老合同'
      })
        .then(() => {
          channel.addVerify(that.applyForm).then(res => {
            if (res.code == 200) {
              Toast.success('申请成功，请等待财务审核')
              that.getContractList()
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    async selectContract(row) {
      if (row.errorMsg) {
        this.claimForm.contractStatus = row.errorMsg
      } else {
        this.claimForm.contractStatus = null
      }
      this.claimForm.contractId = row.contractId
      this.claimForm.contractName = row.contractName
      await newContract.getContract(this.claimForm.contractId).then(res => {
        this.contInfo = res.data
      })
      if (row.custSource == 2) {
        await payment.getExecCustomerByCustName({ contractId: this.contInfo.contractId, execCustomerName: this.payInfo.custName }).then(async res => {
          if (res.code == 200) {
            this.execCustomerList = res.data
            if (this.execCustomerList.length == 1) {
              this.claimForm.execCustId = this.execCustomerList[0].execCustomerId
              this.claimForm.execCustName = this.execCustomerList[0].execCustomerName
              await this.getIncomeType(this.claimForm.execCustId)
              await this.getProjectList02(2, this.claimForm.execCustId)
            }
          }
        })
      } else {
        await this.getIncomeType()
        await this.getProjectList02(1, this.contractId)
      }
      // await this.getIncomeType(this.claimForm.contractId)
      // if (this.contInfo.custSource == 2 && this.type == 'needId') {
      //   await payment.getExecCustomerByCustName({ contractId: this.contInfo.contractId, execCustomerName: this.payInfo.custName }).then(res => {
      //     if (res.code == 200) {
      //       this.execCustomerId = res.data.execCustomerId
      //     } else {
      //       Toast.fail(res.msg)
      //       this.execCustomerId = null
      //       this.projectList = []
      //       return false
      //     }
      //   })
      //   if (this.execCustomerId) {
      //     await newContract.listProject({ bussType: 2, bussId: this.execCustomerId }).then(res => {
      //       if (res.code == 200) {
      //         this.projectList = res.rows
      //       }
      //     })
      //   }
      // } else {
      //   await this.getProjectList(this.claimForm.contractId)
      // }
      // if (this.contInfo.channelType == 2) {
      //   await payment.listExecutive({ contractId: this.contInfo.contractId }).then(res => {
      //     if (res.code == 200) {
      //       this.execCustomerList = res.rows
      //     }
      //   })
      //   if (this.execCustomerList.length == 1) {
      //     this.execCustomerId = this.execCustomerList[0].execCustomerId
      //     this.execCustomerName = this.execCustomerList[0].execCustomerName
      //     this.claimForm.execCustomerId = this.execCustomerList[0].execCustomerId
      //     this.claimForm.execCustomerName = this.execCustomerList[0].execCustomerName
      //     await this.getProjectList02(2, this.execCustomerId)
      //   } else {
      //     this.projectList = []
      //   }
      // }
      // if (this.projectList.length == 1) {
      //   this.claimForm.flowList = []
      //   const obj = {
      //     fundType: null,
      //     fundTypeName: null,
      //     projectId: this.projectList[0].projectId,
      //     projectName: this.projectList[0].projectName,
      //     execCustomerId: this.execCustomerId || null,
      //     execCustomerName: this.execCustomerName || null,
      //     authIds: null,
      //     rechargeMoney: null,
      //     payMoney: this.claimForm.preRechargeMoney,
      //     authIdsList: []
      //   }
      //   if (obj.projectName && obj.projectName.indexOf('代运营') > -1) {
      //     obj.fundType = 1
      //     obj.fundTypeName = '代运营充值'
      //   } else {
      //     obj.fundType = 2
      //     obj.fundTypeName = '媒介充值'
      //   }
      //   // if (this.contInfo.businessTypeName.indexOf('效果运营类') > -1) {
      //   //   if (this.contInfo.operationMode == 2) {
      //   //     obj.fundType = 1
      //   //     obj.fundTypeName = '代运营充值'
      //   //   } else {
      //   //     obj.fundType = 2
      //   //     obj.fundTypeName = '媒介充值'
      //   //   }
      //   // } else if (this.contInfo.businessTypeName.indexOf('数字媒介类') > -1) {
      //   //   obj.fundType = 2
      //   //   obj.fundTypeName = '媒介充值'
      //   // }
      //   await channel.getPayMoney({ contractId: this.claimForm.contractId, fundType: obj.fundType, projectId: obj.projectId, payMoney: obj.payMoney, [this.type]: this.payInfo[this.type] }).then(res => {
      //     if (res.code == 200) {
      //       obj.rechargeMoney = res.data
      //     }
      //   })
      //   this.claimForm.flowList.push(obj)
      // }
      this.selectVisible = false
    },
    async showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'contract') {
        this.picker.columns = this.newIncomeContList.map((ele) => ele.contractNum + '  ' + ele.contractName)
        this.picker.loading = false
      } else if (type === 'execCustomer') {
        // await payment.listExecutive({ contractId: this.contInfo.contractId }).then(res => {
        //   if (res.code == 200) {
        //     this.execCustomerList = res.rows
        //   }
        // })
        this.projectList = []
        this.picker.columns = this.execCustomerList.map((ele) => `${ele.bussUserName}：${ele.execCustomerName}`)
        this.picker.loading = false
      } else if (type === 'project') {
        this.picker.columns = this.projectList.map((ele) => `【${ele.calculationMethodStr}】${getValue(ele.projectName)} | ${ele.industryName ? ele.industryName : '-'}`)
        this.picker.loading = false
      } else if (type === 'accountId') {
        this.picker.columns = this.accountNoList.map((ele) => ele.accountId)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      // const id = this.picker.formKey + 'Id'
      if (this.index || this.index == 0) {
        // if (this.picker.formKey === 'execCustomer') {
        //   this.claimForm.flowList[this.index].execCustomerId = this.execCustomerList[key].execCustomerId
        //   this.claimForm.flowList[this.index][name] = this.execCustomerList[key].execCustomerName
        //   newContract.listProject({ bussType: 2, bussId: this.execCustomerList[key].execCustomerId }).then(res => {
        //     if (res.code == 200) {
        //       this.projectList = res.rows
        //     }
        //   })
        // } else
        if (this.picker.formKey === 'project') {
          this.claimForm.divideAccountList[this.index].projectId = this.projectList[key].projectId
          this.claimForm.divideAccountList[this.index][name] = this.projectList[key].projectName
          this.getPercentage(this.projectList[key].projectId, this.index)
          this.authIdQuery.projectId = this.projectList[key].projectId
          this.getAuthIds()
        } else if (this.picker.formKey === 'accountId') {
          this.claimForm.divideAccountList[this.index].accountId = this.accountNoList[key].accountId
        } else {
          this.claimForm.divideAccountList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.claimForm.divideAccountList[this.index][name] = this.options[optionItem][key].dictLabel
        }
      } else {
        if (this.picker.formKey === 'contract') {
          this.newIncomeContList = this.newIncomeContList.filter(item => {
            return item.contractName.indexOf(this.searchValue) > -1 || item.contractNum.indexOf(this.searchValue) > -1
          })
          this.claimForm.contractId = this.newIncomeContList[key].contractId
          this.claimForm.contractName = this.newIncomeContList[key].contractNum + '  ' + this.newIncomeContList[key].contractName
          await newContract.getContract(this.claimForm.contractId).then(res => {
            this.contInfo = res.data
          })
          this.getIncomeType()
          this.getProjectList(this.claimForm.contractId)
        } else if (this.picker.formKey === 'execCustomer') {
          this.claimForm.execCustId = this.execCustomerList[key].execCustomerId
          this.claimForm.execCustName = this.execCustomerList[key].execCustomerName
          this.getIncomeType(this.claimForm.execCustId)
          this.getProjectList02(2, this.claimForm.execCustId)
        } else {
          this.verifyForm[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.verifyForm[name] = this.options[optionItem][key].dictLabel
        }
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    // 收款识别
    handleAgain(row) {
      Dialog.confirm({
        message: '确认付款单位为:"' + row.custName + '"的数据重新识别收款短信吗?'
      })
        .then(() => {
          payment.addNewIncome(row).then(res => {
            if (res.code === 200) {
              Toast.success('操作成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    async remove(contNewIncomeId) {
      Dialog.confirm({
        message: '是否确认删除此条打款记录'
      })
        .then(() => {
          api.deleteNewIncome(contNewIncomeId).then(res => {
            if (res.code === 200) {
              Toast.success('删除成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    handleConfirm(contNewIncomeMsgId) {
      Dialog.confirm({
        message: '是否确认通过此条' + (this.type == 'needId' ? '发送' : '认领') + '记录？'
      })
        .then(() => {
          api.msgConfirm({ [this.typeMsg]: contNewIncomeMsgId }).then(res => {
            if (res.code === 200) {
              Toast.success('通过成功')
              setTimeout(() => {
                this.getPayInfo(this.contNewIncomeId)
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    handleUnbind(contNewIncomeDetailId) {
      Dialog.confirm({
        message: '是否确认解除该' + (this.type == 'needId' ? '需求发送' : '收款认领') + '的记录？'
      })
        .then(() => {
          api.relieve({ [this.typeDetail]: contNewIncomeDetailId }).then(res => {
            if (res.code === 200) {
              Toast.success('解除成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    handleReissue(contNewIncomeDetailId) {
      Dialog.confirm({
        message: '是否确认无误并重新' + (this.type == 'needId' ? '发送该需求' : '认领该收款') + '记录吗？'
      })
        .then(() => {
          api.reissue({ [this.typeDetail]: contNewIncomeDetailId }).then(res => {
            if (res.code === 200) {
              Toast.success('重新' + (this.type == 'needId' ? '发送' : '认领') + '成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    notMine(contNewIncomeId) {
      Dialog.confirm({
        message: '是否确认这条数据不是你的?'
      })
        .then(() => {
          api.addNewIncomeDetail({ [this.type]: contNewIncomeId, status: 3 }).then(res => {
            if (res.code === 200) {
              Toast.success('操作成功')
              setTimeout(() => {
                if (JSON.parse(sessionStorage.getItem('paymentQuery'))) {
                  this.$router.go(-1)
                } else {
                  this.$router.push({
                    path: '/cont/payment/paymentList',
                    query: { active: '2' }
                  })
                }
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    async handleClaim(val, type) {
      this.contractId = null
      this.contInfo = {}
      this.claimForm.incomeType = null
      this.claimForm.contractName = null
      this.claimForm.divideAccountList = []
      if (type == 'noAgreeMatch') {
        this.isObjection = true
      } else {
        this.isObjection = false
      }
      // this.$refs.claimForm.resetFields()
      // if (this.payInfo.contractCount == 1) {
      this.claimForm.payMoney = this.payInfo.noConfirmMoney
      // this.payMoneyDisabled = true
      // } else {
      //   this.claimForm.payMoney = ''
      //   this.payMoneyDisabled = false
      // }
      await this.getContractList()
      if (this.newIncomeContList.length == 1) {
        await this.selectContract(this.newIncomeContList[0])
      }
      this.claimVisible = true
      // if (val.checkStatus == 1) {
      //   api.newWatersIncomeCont().then(res => {
      //     if (res.code == 200) {
      //       if (res.data.length == 0) {
      //         Toast.fail('该收款信息暂无签约合同记录，请先完善客户合同信息再确认认领。')
      //         return
      //       }
      //       this.claimVisible = true
      //       this.newIncomeContList = res.data
      //       // this.contractId = res.data[0].contractId
      //       // this.claimForm.contractName = res.data[0].contractNum + '  ' + res.data[0].contractName
      //       // this.contInfo = res.data[0]
      //       // this.getIncomeType(this.contractId)
      //     }
      //   })
      // } else {
      //   api.newIncomeCont({ [this.type]: val[this.type] }).then(res => {
      //     if (res.code == 200) {
      //       if (res.data.length == 0) {
      //         Toast.fail('该收款信息暂无签约合同记录，请先完善客户合同信息再确认认领。')
      //         return
      //       }
      //       this.claimVisible = true
      //       this.newIncomeContList = res.data
      //       // this.contractId = res.data[0].contractId
      //       // this.claimForm.contractName = res.data[0].contractNum + '  ' + res.data[0].contractName
      //       // this.contInfo = res.data[0]
      //       // this.getIncomeType(this.contractId)
      //     }
      //   })
      // }
    },
    // getIncomeType(id) {
    //   api.getIncomeType({ contractId: id }).then(response => {
    //     if (response.code === 200) {
    //       this.claimForm.incomeType = response.data
    //     }
    //   })
    // },
    async getIncomeType(execCustomerId) {
      if (!this.contInfo.contractId) {
        return
      }
      await payment.getIncomeType({ contractId: this.contInfo.contractId, execCustomerId, custName: this.payInfo.custName, payMoney: this.payInfo.payMoney }).then(response => {
        if (response.code === 200) {
          this.claimForm.incomeType = response.data.incomeType
          this.claimForm.preRechargeMoney = response.data.preRechargeMoney
          if (Number(response.data.advancesInMoney) > Number(this.claimForm.payMoney)) {
            this.claimForm.advancesInMoney = this.claimForm.payMoney
            this.advancesInMoney = this.claimForm.payMoney
          } else {
            this.claimForm.advancesInMoney = response.data.advancesInMoney
            this.advancesInMoney = response.data.advancesInMoney
          }
          this.advancesPayMoney = response.data.advancesPayMoney
          this.preRechargeMoney = response.data.preRechargeMoney
          if (response.data.incomeType == 0) {
            this.incomeTypeDisabled = true
          } else if (response.data.incomeType == 1) {
            this.incomeTypeDisabled = false
          }
          console.log(this.claimForm)
        } else {
          Toast.fail(response.msg)
        }
      })
    },
    incomeTypeChange(val) {
      if (val == 0 && !this.incomeTypeDisabled) {
        this.claimForm.preRechargeMoney = this.claimForm.advancesInMoney + this.claimForm.preRechargeMoney
        this.claimForm.advancesInMoney = null
        this.advancesPayMoney = null
        this.claimForm.preRechargeMoney = Number(this.claimForm.payMoney) - Number(this.claimForm.advancesInMoney) - Number(this.claimForm.exposureMoney)
      } else {
        this.claimForm.exposureMoney = null
        this.claimForm.isExposure = 0
        this.getIncomeType(this.claimForm.execCustId)
      }
    },
    exposureChange(val) {
      if (val == 0) {
        this.claimForm.exposureMoney = null
        this.claimForm.preRechargeMoney = Number(this.claimForm.payMoney) - Number(this.claimForm.advancesInMoney) - Number(this.claimForm.exposureMoney)
      }
    },
    async getProjectList(contractId) {
      await newContract.listProject({ bussType: 1, bussId: contractId }).then(res => {
        if (res.code == 200) {
          this.projectList = res.rows
        }
      })
    },
    // 获取项目名称列表
    async getProjectList02(type, id) {
      await newContract.listProject({ bussType: type, bussId: id }).then(res => {
        if (res.code == 200) {
          this.projectList = res.rows
          if (this.projectList.length === 1 && this.claimForm.preRechargeMoney) {
            this.claimForm.divideAccountList.push({
              projectId: this.projectList[0].projectId,
              projectName: this.projectList[0].projectName,
              payMoney: null,
              percentage: null,
              rechargeMoney: null,
              channelPercentage: null,
              channelPayMoney: null
            })
            this.getPercentage(this.projectList[0].projectId, 0)
            this.authIdQuery.projectId = this.projectList[0].projectId
            this.getAuthIds()
          }
        }
      })
    },
    async getPercentage(projectId, index) {
      await newContract.listProjectPercentage({ projectId, bussType: this.claimForm.execCustId ? 2 : 1, bussId: this.claimForm.execCustId || this.contractId }).then(res => {
        if (res.code === 200) {
          if (res.data.length === 1) {
            this.claimForm.divideAccountList[index].percentage = res.data[0].percentageChannel
            this.claimForm.divideAccountList[index].channelPercentage = res.data[0].percentage
          } else {
            this.claimForm.divideAccountList[index].percentage = 0
            this.claimForm.divideAccountList[index].channelPercentage = 0
          }
          this.claimForm.divideAccountList[index].payMoney = this.claimForm.preRechargeMoney
          if (this.claimForm.divideAccountList.length === 0 || this.claimForm.divideAccountList.length === 1) {
            this.getPayMoney('payMoney', this.claimForm.preRechargeMoney, 0)
          }
        }
      })
    },
    async getAuthIds(projectId) {
      await payment.listByProjectId(this.authIdQuery).then(res => {
        if (res.code == 200) {
          this.accountNoList = res.data
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    async onSearchAccount() {
      this.authIdQuery.projectId = this.claimForm.divideAccountList[this.index].projectId
      await this.getAuthIds(this.claimForm.divideAccountList[this.index].projectId)
      // this.accountNoList = this.accountNoList.filter(item => {
      //   return (item.accountId.toString()).indexOf(this.searchValue) > -1
      // })
      this.picker.columns = this.accountNoList.map((ele) => ele.accountId)
    },
    async getSum() {
      if (Number(this.claimForm.payMoney) + this.payInfo.confirmMoney > this.payInfo.payMoney) {
        Toast.fail('确认金额不能大于收款金额')
        this.claimForm.payMoney = ''
      } else {
        await payment.getIncomeType({ contractId: this.contInfo.contractId, execCustomerId: this.claimForm.execCustId, custName: this.payInfo.custName, payMoney: this.claimForm.payMoney }).then(response => {
          if (response.code === 200) {
            this.claimForm.incomeType = response.data.incomeType
            this.claimForm.preRechargeMoney = response.data.preRechargeMoney
            if (Number(response.data.advancesInMoney) > Number(this.claimForm.payMoney)) {
              this.claimForm.advancesInMoney = this.claimForm.payMoney
              this.advancesInMoney = this.claimForm.payMoney
            } else {
              this.claimForm.advancesInMoney = response.data.advancesInMoney
              this.advancesInMoney = response.data.advancesInMoney
            }
            this.advancesPayMoney = response.data.advancesPayMoney
            this.preRechargeMoney = response.data.preRechargeMoney
            this.claimForm.flowList = []
            this.claimForm.divideAccountList = []
          }
        })
      }
      this.claimForm.exposureMoney = ''
      this.claimForm.isExposure = 0
    },
    verifiMoney(type) {
      if (type === 'advancesInMoney') {
        if (Number(this.claimForm.advancesInMoney) > this.claimForm.payMoney || Number(this.claimForm.advancesInMoney) > this.advancesPayMoney) {
          Toast.fail('垫款回款金额不得大于确认金额或累计垫款未回款')
          this.claimForm[type] = this.advancesInMoney
          this.claimForm.preRechargeMoney = this.preRechargeMoney
          this.claimForm.exposureMoney = ''
          this.claimForm.isExposure = 0
          return
        }
        if (Number(this.claimForm.payMoney) - Number(this.claimForm.advancesInMoney) - Number(this.claimForm.exposureMoney) < 0) {
          Toast.fail('服务费不得超过预充值金额')
          this.claimForm[type] = ''
        }
        this.claimForm.preRechargeMoney = Number(this.claimForm.payMoney) - Number(this.claimForm.advancesInMoney) - Number(this.claimForm.exposureMoney)
      } else if (type === 'exposureMoney') {
        if (Number(this.claimForm.payMoney) - Number(this.claimForm.advancesInMoney) - Number(this.claimForm.exposureMoney) < 0) {
          Toast.fail('服务费不得超过预充值金额')
          this.claimForm[type] = ''
        }
        this.claimForm.preRechargeMoney = Number(this.claimForm.payMoney) - Number(this.claimForm.advancesInMoney) - Number(this.claimForm.exposureMoney)
      }
    },
    // 返回布尔值
    beforeRead(file) {
      const imgArr = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/vnd.adobe.photoshop']
      if (!imgArr.some((item) => { return file.type === item })) {
        Toast.fail('请上传 图片 文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast.fail('文件大小不能超过 10mb')
    },
    async uploadPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.claimForm.payImg = res.url
            this.pictureList = []
            this.pictureList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
          Toast.fail(error)
        })
    },
    handleRemove(file) {
      this.claimForm.payImg = ''
      this.pictureList = []
      return true
    },
    // 认领
    async claimBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.claimForm.validate()
          this.claimForm[this.type] = this.payInfo[this.type]
          this.claimForm.contractId = this.contInfo.contractId
          this.claimForm.status = this.payInfo.checkStatus == 1 ? 2 : 1
          if (this.isObjection) {
            api.noAgreeMatch(this.claimForm).then(res => {
              if (res.code == 200) {
                Toast.success('异议提交成功!')
                this.claimVisible = false
                setTimeout(() => {
                  if (JSON.parse(sessionStorage.getItem('paymentQuery'))) {
                    this.$router.go(-1)
                  } else {
                    this.$router.push({
                      path: '/cont/payment/paymentList',
                      query: { active: '5' }
                    })
                  }
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            })
          } else {
            const beforeRes = await payment.claimingBefore({ contractId: this.contInfo.contractId, execCustomerId: this.claimForm.execCustId, custName: this.payInfo.custName })
            Dialog.confirm({
              messageAlign: 'left',
              message: beforeRes.data.num === 1
                ? '<div style="color: #E6A23C;">您当前合同:"' + this.contInfo.contractName + (beforeRes.data.execCustomerName ? '下的执行客户' + beforeRes.data.execCustomerName : '') + '"有垫款审批记录或媒介未确认的垫款记录，' + (this.type == 'needId' ? '发送当前需求后将不能对垫款记录进行平账，您确认要发送吗' : '认领当前收款后将不能对垫款记录进行平账，您确认要认领吗') + '？</div><div class="confirm_tip">垫款记录不能平账会造成后面垫款记录逾期风险，请谨慎操作！</div>'
                : '确认要提交合同信息:"' + this.contInfo.contractName + '"的' + (this.type == 'needId' ? '需求发送吗?请仔细核对后发送!' : '收款认领吗?请仔细核对后认领!'),
              cancelButtonText: beforeRes.data.num === 1 ? '垫款确认' : '取消'
            })
              .then(() => {
                api.addNewIncomeDetail(this.claimForm).then(res => {
                  if (res.code == 200) {
                    this.claimVisible = false
                    Toast.success((this.type == 'needId' ? '发送' : '认领') + '成功!')
                    setTimeout(() => {
                      if (JSON.parse(sessionStorage.getItem('paymentQuery'))) {
                        this.$router.go(-1)
                      } else {
                        this.$router.push({
                          path: '/cont/payment/paymentList',
                          query: { active: '2' }
                        })
                      }
                    }, 500)
                    done()
                  } else {
                    Toast.fail(res.msg)
                  }
                })
              })
              .catch(() => {
                if (beforeRes.data.num === 1) {
                  this.$router.push({
                    path: '/cont/advances/approvalList'
                  })
                }
              })
          }
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        this.claimForm.flowList = []
        this.claimForm.divideAccountList = []
        return done()
      }
    },
    getOptions() {
      // 框架类型
      this.getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = res.data
      })
      // 客户来源类型
      this.getDicts('cust_source').then(res => {
        this.options.custSourceOptions = res.data
      })
      // 垫款方式
      this.getDicts('pay_type').then(res => {
        this.options.payTypeOptions = res.data
      })
      this.getDicts('credit_cycle_type').then(res => {
        this.options.creditCycleTypeOptions = res.data
      })
      // 渠道公司
      this.getDicts('channel_company').then(res => {
        this.options.channelCompanyOptions = res.data
      })
    },
    showImg(val) {
      this.imageArr = []
      this.imageArr.push(val)
      this.imageShow = true
    },

    // 分账
    addExecutive() {
      const peo = {
        projectId: null,
        payMoney: null,
        percentage: null,
        rechargeMoney: null,
        channelPercentage: null,
        channelPayMoney: null
      }
      this.claimForm.divideAccountList.push(peo)
      const res = this.activeNames.some(item => {
        return this.claimForm.divideAccountList.length - 1 === item
      })
      if (res === false) {
        this.activeNames.push(this.claimForm.divideAccountList.length - 1)
      }
    },
    deleteExecutive(item) {
      this.claimForm.divideAccountList.splice(item, 1)
    },
    // 计算账户币或者充值金额
    async getPayMoney(type, val, index) {
      // const params = {
      //   contractId: this.contInfo.contractId,
      //   [this.type]: this.mainId,
      //   fundType: this.claimForm.flowList[index].fundType,
      //   projectId: this.claimForm.flowList[index].projectId
      // }
      // if (type == 'payMoney') {
      //   params.payMoney = val
      //   if ((this.claimForm.flowList[index].fundType == 1 || this.claimForm.flowList[index].fundType == 2) && this.claimForm.flowList[index].projectId) {
      //     channel.getPayMoney(params).then(res => {
      //       if (res.code == 200) {
      //         this.claimForm.flowList[index].rechargeMoney = res.data
      //       } else {
      //         Toast.fail(res.msg)
      //       }
      //     })
      //   } else {
      //     this.claimForm.flowList[index].rechargeMoney = null
      //   }
      // } else if (type == 'rechargeMoney') {
      //   params.rechargeMoney = val
      //   channel.getPayMoney(params).then(res => {
      //     if (res.code == 200) {
      //       this.claimForm.flowList[index].payMoney = res.data
      //     } else {
      //       Toast.fail(res.msg)
      //     }
      //   })
      // }
      const params = {
        payMoney: val,
        contractId: this.claimForm.contractId,
        [this.type]: this.mainId,
        percentage: this.claimForm.divideAccountList[index].percentage,
        projectId: this.claimForm.divideAccountList[index].projectId
      }
      await channel.getChannelPayMoney(params).then(res => {
        if (res.code == 200) {
          this.claimForm.divideAccountList[index].rechargeMoney = res.data
        }
      })
      const paramsChannel = {
        rechargeMoney: this.claimForm.divideAccountList[index].rechargeMoney,
        contractId: this.claimForm.contractId,
        [this.type]: this.mainId,
        percentageChannel: this.claimForm.divideAccountList[index].channelPercentage,
        projectId: this.claimForm.divideAccountList[index].projectId
      }
      await channel.getCustChannelPayMoney(paramsChannel).then(res => {
        if (res.code == 200) {
          this.claimForm.divideAccountList[index].channelPayMoney = res.data
        }
      })
    },
    // 查看分账明细
    handleExecutiveDetail(detailId, channelType) {
      this.channelType = channelType
      this.handleExecutiveList(detailId)
      this.showExecutive = true
    },
    // 获取分账明细列表
    async handleExecutiveList(detailId) {
      this.loading = true
      let params = {}
      if (this.$route.query.type == 'payment') {
        params = { needDetailId: detailId, dataType: 1 }
      } else if (this.$route.query.type == 'channel') {
        params = { needDetailId: detailId, dataType: 2 }
      }
      const res = await channel.listCapitalFlow(params)
      if (res.code === 200) {
        this.executiveList = res.rows
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

/deep/.van-dialog__confirm{
  color: #ee0a24;
  border-top: 0.01333rem solid #ccc;
}
.verifyClue /deep/.van-dialog__content {
  height: 80%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
/deep/.van-list{
  padding: 0;
}
.tagTitle{
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
}
.contract_detail{
  .item{
    display: inline-block;
  }
  .value{
    color: #333;
  }
}
</style>
